/**
 * Safe access to the cached user in localStorage.
 *
 * Why: several pages did `JSON.parse(localStorage.getItem("user"))` with no
 * guard. When the value is corrupted (the string "undefined", "null", or
 * invalid JSON — which happens after a failed OAuth callback or a partial
 * logout) JSON.parse throws during render and React unmounts the whole tree:
 * the "/settings abre tela branca" bug. This helper never throws; a corrupted
 * value is removed so the caller can redirect to /login cleanly.
 */
export function getStoredUser<T = any>(): T | null {
  try {
    const raw = localStorage.getItem("user");
    if (!raw || raw === "undefined" || raw === "null") {
      if (raw) localStorage.removeItem("user");
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      localStorage.removeItem("user");
      return null;
    }
    return parsed as T;
  } catch {
    localStorage.removeItem("user");
    return null;
  }
}

export function setStoredUser(user: unknown): void {
  if (!user || typeof user !== "object") {
    localStorage.removeItem("user");
    return;
  }
  localStorage.setItem("user", JSON.stringify(user));
}

export function clearSession(): void {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
}
